import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import Lightbox from 'yet-another-react-lightbox';
import 'swiper/css';
import 'swiper/css/navigation';
import 'yet-another-react-lightbox/styles.css';

function ImageCarousel({ imgFolder, imgCount }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const images = Array.from({ length: imgCount }, (_, i) => i + 1);
  const slides = images.map(count => ({ src: `/img/${imgFolder}/${count}.jpg` }));

  return (
    <>
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        spaceBetween={10}
        slidesPerView={1}
        loop={true}
        breakpoints={{
          768: { slidesPerView: 2 },
        }}
        autoplay={{
          delay: 3000,
        }}
      >
        {images.map((count, index) => (
          <SwiperSlide
            key={count}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '380px', cursor: 'pointer' }}
            onClick={() => { setLightboxIndex(index); setLightboxOpen(true); }}
          >
            <img
              src={`/img/${imgFolder}/${count}.jpg`}
              alt={`Slide ${count}`}
              style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '15px' }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={slides}
        index={lightboxIndex}
      />
    </>
  );
}

export default ImageCarousel;